<mat-expansion-panel class="orange-panel" [togglePosition]="'after'" [hideToggle]="true" (opened)="isPanelExpanded = true"
  (closed)="isPanelExpanded = false">
  <mat-expansion-panel-header>
    <mat-panel-title>
      Beitrag erstellen <i class="fa fa-angle-down" [class.rotate-icon]="isPanelExpanded"></i>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div class="entry" (click)="StateService.goto('/market/create',{},true,true)">
    <i class="fa fa-euro-sign"></i>
    <div>Zimmereibedarf verkaufen</div>
  </div>
  <div class="entry" (click)="StateService.goto('/market/create',{},true,true)">
    <i class="fas fa-shopping-cart"></i>
    <div>Zimmereibedarf suchen</div>
  </div>
  <div class="entry" (click)="StateService.goto('/job/create',{},true,true)">
    <i class="fas fa-user-plus"></i>
    <div>Stellenanzeige posten</div>
  </div>
  <div class="entry" (click)="StateService.goto('/job/create',{},true,true)">
    <i class="fas fa-search-plus"></i>
    <div>Stellengesuch posten</div>
  </div>
  <div class="entry" (click)="StateService.goto('/blog/create',{},true,true)">
    <i class="fas fa-list-alt"></i>
    <div>Fachbeitrag erstellen</div>
  </div>
  <div class="entry" (click)="StateService.goto(
      '/blog/create',
      {preselected:{category:CategoriesService.eventcat}},
      true,
      true
    )">
    <i class="far fa-calendar-check"></i>
    <div>Veranstaltung erstellen</div>
  </div>
  <div class="entry"
    (click)="StateService.goto('/blog/create',{preselected:{category:CategoriesService.videocat}},true,true)">
    <i class="fas fa-video"></i>
    <div>Video veröffentlichen</div>
  </div>
</mat-expansion-panel>